import React from 'react';
import './styles.scss';

function DeleteIcon(props = {}) {
  return <span {...props} className="draggable-row-delete-icon" />;
}

export default DeleteIcon;
